export const wafersMap: Record<number, string> = {
  1: "D1",
  2: "D2",
  3: "D3",
  4: "D4",
  5: "D5",
  6: "D6",
  7: "D7",
  8: "D8",
  9: "D9",
  10: "D10",
  11: "D11",
  12: "D12",
  13: "D13",
  14: "D14",
  15: "D15",
  16: "D16",
  17: "D17",
  18: "D18",
  19: "D19",
  20: "D20",
  21: "D21",
  22: "D22",
  23: "D23",
  24: "D24",
  25: "D25",
};
